import {CatalogConfig} from '../types'

// WP-D-frontend — admin panel for the D-A sensitive-field registry, mounted on the generic catalog
// screen. Admins add/edit/deactivate which profile/member fields are treated as sensitive; the
// backend serializer masking (nobilis-social feat/sensitive-field-masking) reads this registry and
// replaces those fields with the RESTRICTED marker for users lacking the module's
// can_view_sensitive_info permission.
//
// BLOCKED: the endpoint below ships in nobilis-social `feat/sensitive-field-masking` (WP-D-backend),
// not yet on dev. Built against that contract; verify once it deploys.
//
// Contract (admin CRUD, camelCased): GET/POST /api/v1/users/sensitive-fields/,
//   GET/PATCH/DELETE /api/v1/users/sensitive-fields/<id>/
//   entry: { id, fieldName, label, category, moduleSlug, active, createdAt, updatedAt }
//   category ∈ bank_payment | tax_id | passport_id | home_address | net_worth | confidential_tab
export const sensitiveFieldsConfig: CatalogConfig = {
  slug: 'sensitive-fields',
  endpoint: '/users/sensitive-fields/',
  titleId: 'CATALOG.SENSITIVE_FIELDS.TITLE',
  singularId: 'CATALOG.SENSITIVE_FIELDS.SINGULAR',
  primaryField: 'fieldName',
  // Registry rows use the `active` soft-delete convention (deactivate = stop masking that field).
  softDelete: {field: 'active', activeValue: true},
  // Server-side pagination + status. statusParam 'active' pushes the active/inactive dropdown to
  // the backend (?active=true|false; 'All' omits it) so it filters the whole set, not one page.
  // `active` is distinct from the model's is_deleted soft-delete (the list already excludes
  // is_deleted rows). Requires the backend `active` filter (nobilis-social SensitiveFieldRegistryFilter).
  serverSide: {searchParam: 'search', statusParam: 'active'},
  fields: [
    {
      name: 'fieldName',
      labelId: 'CATALOG.SENSITIVE_FIELDS.FIELD.FIELD_NAME',
      type: 'text',
      required: true,
      maxLength: 100,
      showInTable: true,
      searchable: true,
    },
    {
      name: 'label',
      labelId: 'CATALOG.SENSITIVE_FIELDS.FIELD.LABEL',
      type: 'text',
      maxLength: 150,
      showInTable: true,
      searchable: true,
    },
    {
      name: 'category',
      labelId: 'CATALOG.SENSITIVE_FIELDS.FIELD.CATEGORY',
      type: 'select',
      required: true,
      showInTable: true,
      options: [
        {value: 'bank_payment', labelId: 'CATALOG.SENSITIVE_FIELDS.CATEGORY.BANK'},
        {value: 'tax_id', labelId: 'CATALOG.SENSITIVE_FIELDS.CATEGORY.TAX'},
        {value: 'passport_id', labelId: 'CATALOG.SENSITIVE_FIELDS.CATEGORY.ID_DOC'},
        {value: 'home_address', labelId: 'CATALOG.SENSITIVE_FIELDS.CATEGORY.ADDRESS'},
        {value: 'net_worth', labelId: 'CATALOG.SENSITIVE_FIELDS.CATEGORY.WEALTH'},
        {value: 'confidential_tab', labelId: 'CATALOG.SENSITIVE_FIELDS.CATEGORY.CONFIDENTIAL'},
      ],
    },
    {
      name: 'moduleSlug',
      labelId: 'CATALOG.SENSITIVE_FIELDS.FIELD.MODULE',
      type: 'text',
      maxLength: 50,
      showInTable: true,
    },
  ],
}
